<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>驿站</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                            :value="item.id + ''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="驿站名称">
                    <el-input v-model="listQuery.postStationName" placeholder="请输入驿站名称" clearable></el-input>
                </el-form-item>

                <el-form-item label="服务站类型">
                    <el-select v-model="listQuery.type" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in typeKey" :key="index" :label="item" :value="index + ''">
                        </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="el-icon-plus" plan @click="addPostStation">新增驿站</el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="" label="城市">
                    <template slot-scope="scope">
                        {{ getcity(scope.row.cityId) }}
                    </template>
                </el-table-column>
                <el-table-column prop="postStationName" label="驿站名称"></el-table-column>
                <el-table-column prop="houseName" label="驿站类型">
                    <template slot-scope="scope">
                        <span style="color:orange;">{{ typeKey[scope.row.type] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                <el-table-column prop="updateTime" :formatter="dateFormatA" label="修改时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button v-per="'updatestation'" type="text" icon="el-icon-edit"
                            @click="handleEditPost(scope.row)">编辑驿站</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog :title="addFrom.id ? '编辑' : '新增驿站'" :visible.sync="showAdd" width="400px"
            :close-on-click-modal="false" center>
            <el-form>
                <el-form-item label="城市">
                    <el-select v-model="addFrom.cityId" clearable placeholder="请选择城市" filterable>
                        <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="驿站名称">
                    <el-input style="width:180px;" clearable v-model="addFrom.postStationName"></el-input>
                </el-form-item>
                <el-form-item label="驿站类型">
                    <el-select v-model="addFrom.type" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in typeKey" :key="index" :label="item" :value="index + ''" >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showAdd = false">关闭</el-button>
                <el-button type="primary" @click="saveUpdate">提交</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            typeKey: { 1: '保洁站', 2: '品类站', 3: '综合站', 4: '中介类服务站', 5: '改约服务站', 6: '保姆站' },
            listData: [],
            cityList: [],
            sysUserList: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                cityId: "",
                postStationName: "",
                type: "",
            },
            addFrom: {
                cityId: null,
                postStationName: null,
                type: null
            },
            showAdd: false,
        };
    },

    created() {
        this.getAllCity();
        this.querySearch();
    },
    methods: {
        handleDel(index, row) {
            this.$confirm("是否确定删除?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    service
                        .$axiosDeletePostStation({
                            id: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("删除成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });
        },
        addPostStation() {
            this.showAdd = true;
            this.addFrom = {
                cityId: null,
                postStationName: null,
                type: null
            };
        },
        handleEditPost(row) {
            this.showAdd = true;
            this.addFrom = {
                id: row.id,
                cityId: row.cityId,
                postStationName: row.postStationName,
                type: row.type+''
            };
        },
        saveUpdate() {
            service.$axiosAddPostStation(this.addFrom).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showAdd = false;
                    this.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },
        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            service.$axiosGetStationPageList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity().then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getSysUser() {
            //城市下拉框
            service.$axiosSysUsergetallUser().then((res) => {
                if (res.data.errno == 0) {
                    this.sysUserList = res.data.data;
                }
            });
        },
        getcity(id) {
            let nm = null;
            this.cityList.forEach((e) => {
                if (e.id == id) {
                    nm = e.cityName;
                }
            });
            return nm;
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}

.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>